<template>
  <nav class="global-sidebar">
    <ul>
      <li 
        v-for="app in availableApps" 
        :key="app.id" 
        :class="{ active: app.id === currentAppId }"
        @click="selectApp(app.id)"
        :title="app.name"
      >
        <img v-if="app.iconUrl" :src="app.iconUrl" :alt="`${app.name} icon`" class="app-icon" />
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useAppStore } from '../stores/appStore';

const appStore = useAppStore();

const availableApps = computed(() => appStore.availableApps);
const currentAppId = computed(() => appStore.currentAppId);

const selectApp = (appId: string) => {
  appStore.setCurrentApp(appId);
};
</script>

<style scoped>
.global-sidebar {
  width: var(--global-sidebar-width, 60px); /* Updated default and reflects new width */
  background-color: #5E6977; /* Changed to match header */
  color: white;
  padding-top: 10px; /* Adjusted padding */
  height: calc(100vh - var(--global-header-height, 60px)); /* Full height minus header */
  position: fixed; /* Or absolute, depending on layout */
  top: var(--global-header-height, 60px); /* Position below header */
  left: 0;
  overflow-y: auto;
  /* box-shadow: 2px 0 5px rgba(0,0,0,0.1); */ /* Removed box-shadow */
  display: flex; /* Added for centering content */
  flex-direction: column; /* Added for centering content */
  align-items: center; /* Center icons horizontally */
}

.global-sidebar ul {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%; /* Ensure ul takes full width for alignment */
}

.global-sidebar li {
  padding: 15px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease;
  width: 100%;
}

/* Add margin-top for the first child */
.global-sidebar li:first-child {
  margin-top: 30px;
}

.global-sidebar li:hover {
  background-color: #4A5460;
}

.global-sidebar li.active {
  background-color: #4A5460;
  font-weight: bold;
  /* margin-top: 30px; */ /* REMOVED: Active item no longer gets extra top margin */
}

.app-icon {
  width: 24px;
  height: 24px;
  margin-right: 0; /* Removed margin as text is gone */
}
</style> 